import { ComponentProps } from 'react';
import { FieldWrapper } from '../FieldWrapper';
import { TextInput } from '../FormItems';

type FieldWrapperProps = ComponentProps<typeof FieldWrapper>;

type Props = {
  textInput?: ComponentProps<typeof TextInput>;
  fieldWrapperProps: Omit<FieldWrapperProps, 'children'>;
};

export const TextInputField: React.FC<Props> = ({
  textInput,
  fieldWrapperProps: { htmlFor, labelType, labelText, beforeMessage, errorMessages },
  ...rest
}) => {
  return (
    <FieldWrapper
      htmlFor={htmlFor}
      labelType={labelType}
      labelText={labelText}
      beforeMessage={beforeMessage}
      errorMessages={errorMessages}
    >
      <TextInput id={htmlFor} {...textInput} {...rest} />
    </FieldWrapper>
  );
};
